import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance,
  tablezpetcq9vbay1 as table,
} from '../components/table.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  format2qj76aukcztvp as format,
  Companion_instance3t7kgujds2u7a as Companion_instance_0,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/YearMonth.mjs';
import {
  h2ld0l0a2c9zpb as h2,
  subtext2yjmf1ok7kb40 as subtext,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  get_entries3frsl8u2zqes2 as get_entries,
  get_entries3htl3g20ei9sb as get_entries_0,
  IDqqik72jjbpsn as ID,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { dialog3sxbjr735jrum as dialog } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  Cents__toString_impl_ko5hxm1a9pwstsznn43 as Cents__toString_impl_ko5hxm,
  Cents1lsbs5l1tlgw as Cents,
} from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance_1,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { EmployerMonthAggregates15vmzuxkabqjv as EmployerMonthAggregates } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/employerAggregations.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_employerfduycfo0q5pn as get_employer,
  get_month19qfpo3x38uey as get_month,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { eq353yrgcpovoi1 as eq } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  goBackButton1g9k0xsmfm57i as goBackButton,
} from '../components/view-utilities.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Companion_getInstance3rwcbkvzrbmti as Companion_getInstance_1 } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/format/YearMonthFormat.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { char1r4ssccmdfesy as char } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/format/DateTimeFormatBuilder.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_monthFormat() {
  _init_properties_EmployerMonthsPage_kt__pkjj37();
  return monthFormat;
}
var monthFormat;
function statsTable($this, $receiver, groupName, rows) {
  var tmp = _Constant___init__impl__v45mub(rows);
  var tmp_0 = EmployerMonthsPage$statsTable$lambda;
  var tmp_1 = Companion_instance;
  var tmp_2 = ($this$text) => groupName;
  var tmp_3 = tmp_1.text_y5ktm4_k$(tmp_2, 2.0, EmployerMonthsPage$statsTable$lambda_0);
  var tmp_4 = Companion_instance;
  var tmp_5 = EmployerMonthsPage$statsTable$lambda_1;
  var tmp_6 = tmp_4.text$default_gwb2zv_k$(tmp_5, VOID, EmployerMonthsPage$statsTable$lambda_2);
  var tmp_7 = Companion_instance;
  var tmp_8 = EmployerMonthsPage$statsTable$lambda_3;
  var tmp_9 = tmp_7.text$default_gwb2zv_k$(tmp_8, VOID, EmployerMonthsPage$statsTable$lambda_4);
  var tmp_10 = Companion_instance;
  var tmp_11 = EmployerMonthsPage$statsTable$lambda_5;
  return table($receiver, new (Constant())(tmp), tmp_0, [tmp_3, tmp_6, tmp_9, tmp_10.text$default_gwb2zv_k$(tmp_11, VOID, EmployerMonthsPage$statsTable$lambda_6)]);
}
function EmployerMonthsPage$render$lambda$slambda($m, $$this$button, this$0) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $m;
    var month = yield* await_0(this_0, $completion);
    var tmp = $$this$button.get_context_h02k06_k$();
    dialog(tmp, VOID, ($this$dialog, it) => {
      // Inline function 'com.lightningkite.kiteui.views.card' call
      var this_0 = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_rem(40));
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_1 = themed(this_0, CardSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_1.willAddChild_hz2iwc_k$(element);
      element.set_vertical_nuap32_k$(true);
      h2(element, format(month.month_1, get_monthFormat()));
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0 = get_entries();
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element_0 = _iterator__ex2g4s.next_20eer_k$();
        var tmp0_safe_receiver = month.byAgeGroup_1.get_wei43m_k$(element_0);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = to(element_0.displayName_1, tmp0_safe_receiver);
        }
        var tmp0_safe_receiver_0 = tmp;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination.add_utx5q5_k$(tmp0_safe_receiver_0);
        }
      }
      statsTable(this$0, element, 'Age group', destination);
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0_0 = get_entries_0();
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = tmp0_0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var element_1 = _iterator__ex2g4s_0.next_20eer_k$();
        var tmp0_safe_receiver_1 = month.byProviderType_1.get_wei43m_k$(element_1);
        var tmp_0;
        if (tmp0_safe_receiver_1 == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_0 = to(element_1.displayName_1, tmp0_safe_receiver_1);
        }
        var tmp0_safe_receiver_2 = tmp_0;
        if (tmp0_safe_receiver_2 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_0.add_utx5q5_k$(tmp0_safe_receiver_2);
        }
      }
      statsTable(this$0, element, 'Provider type', destination_0);
      element.onStartup_vrxh3i_k$();
      this_1.addChild_2qpft2_k$(element);
      return Unit_instance;
    });
    return Unit_instance;
  }), 1);
}
function EmployerMonthsPage$render$lambda($this$text) {
  return 'Month';
}
function EmployerMonthsPage$render$lambda_0($this$text, it) {
  return format(it.month_1, get_monthFormat());
}
function EmployerMonthsPage$render$lambda_1($this$text) {
  return 'Placements';
}
function EmployerMonthsPage$render$lambda_2($this$text, it) {
  return it.total_1.childPlacements_1.toString();
}
function EmployerMonthsPage$render$lambda_3($this$text) {
  return 'Children';
}
function EmployerMonthsPage$render$lambda_4($this$text, it) {
  return it.total_1.children_1.toString();
}
function EmployerMonthsPage$render$lambda_5($this$text) {
  return 'Families';
}
function EmployerMonthsPage$render$lambda_6($this$text, it) {
  return it.total_1.families_1.toString();
}
function EmployerMonthsPage$render$lambda_7($this$text) {
  return 'Total cost of care';
}
function EmployerMonthsPage$render$lambda_8($this$text, it) {
  var tmp0_safe_receiver = it.breakdown_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.totalCostOfCare_1;
  var tmp;
  var tmp_0 = tmp1_safe_receiver;
  if ((tmp_0 == null ? null : new (Cents())(tmp_0)) == null) {
    tmp = null;
  } else {
    tmp = Cents__toString_impl_ko5hxm(tmp1_safe_receiver);
  }
  var tmp2_elvis_lhs = tmp;
  return tmp2_elvis_lhs == null ? 'Pending' : tmp2_elvis_lhs;
}
function EmployerMonthsPage$render$lambda_9($this$text) {
  return 'Employer share';
}
function EmployerMonthsPage$render$lambda_10($this$text, it) {
  var tmp0_safe_receiver = it.breakdown_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.employerShare_1;
  var tmp;
  var tmp_0 = tmp1_safe_receiver;
  if ((tmp_0 == null ? null : new (Cents())(tmp_0)) == null) {
    tmp = null;
  } else {
    tmp = Cents__toString_impl_ko5hxm(tmp1_safe_receiver);
  }
  var tmp2_elvis_lhs = tmp;
  return tmp2_elvis_lhs == null ? 'Pending' : tmp2_elvis_lhs;
}
function EmployerMonthsPage$render$lambda_11($this$text) {
  return 'Administration fee';
}
function EmployerMonthsPage$render$lambda_12($this$text, it) {
  var tmp0_safe_receiver = it.breakdown_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.employerAdministrationFee_1;
  var tmp;
  var tmp_0 = tmp1_safe_receiver;
  if ((tmp_0 == null ? null : new (Cents())(tmp_0)) == null) {
    tmp = null;
  } else {
    tmp = Cents__toString_impl_ko5hxm(tmp1_safe_receiver);
  }
  var tmp2_elvis_lhs = tmp;
  return tmp2_elvis_lhs == null ? 'Pending' : tmp2_elvis_lhs;
}
function EmployerMonthsPage$render$lambda_13($this$text) {
  return 'Grant match';
}
function EmployerMonthsPage$render$lambda_14($this$text, it) {
  var tmp0_safe_receiver = it.breakdown_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.grantMatch_1;
  var tmp;
  var tmp_0 = tmp1_safe_receiver;
  if ((tmp_0 == null ? null : new (Cents())(tmp_0)) == null) {
    tmp = null;
  } else {
    tmp = Cents__toString_impl_ko5hxm(tmp1_safe_receiver);
  }
  var tmp2_elvis_lhs = tmp;
  return tmp2_elvis_lhs == null ? 'Pending' : tmp2_elvis_lhs;
}
function EmployerMonthsPage$render$lambda_15($this$shownWhen) {
  return get_current(Companion_instance_1).equals(Platform_Web_getInstance());
}
function EmployerMonthsPage$statsTable$lambda($this$table, it) {
  return $this$table;
}
function EmployerMonthsPage$statsTable$lambda_0($this$text, it) {
  return it.first_1;
}
function EmployerMonthsPage$statsTable$lambda_1($this$text) {
  return 'Placements';
}
function EmployerMonthsPage$statsTable$lambda_2($this$text, it) {
  return it.second_1.childPlacements_1.toString();
}
function EmployerMonthsPage$statsTable$lambda_3($this$text) {
  return 'Children';
}
function EmployerMonthsPage$statsTable$lambda_4($this$text, it) {
  return it.second_1.children_1.toString();
}
function EmployerMonthsPage$statsTable$lambda_5($this$text) {
  return 'Families';
}
function EmployerMonthsPage$statsTable$lambda_6($this$text, it) {
  return it.second_1.families_1.toString();
}
var EmployerMonthsPageClass;
function EmployerMonthsPage() {
  if (EmployerMonthsPageClass === VOID) {
    class $ {
      constructor(id) {
        this.id_1 = id;
        var tmp = this;
        tmp.employer_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$();
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance_0();
          var tmp$ret$0 = toDuration(5, DurationUnit_MINUTES_getInstance());
          return $this$remember.awaitNotNull_2lqt5h_k$(tmp.item$default_6j9a06_k$(new (ID())(this.id_1), tmp$ret$0));
        });
        var tmp_0 = this;
        tmp_0.months_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employerMonthAggregates_z5j4ls_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(EmployerMonthAggregates()), arrayOf([]), false));
          var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$3);
          var tmp_1 = eq(get_employer(it), new (ID())(this.id_1));
          // Inline function 'com.lightningkite.services.database.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(EmployerMonthAggregates()), arrayOf([]), false));
          var tmp$ret$10 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$10);
          this_0.descending_tl4o2_k$(get_month(it_0));
          var tmp$ret$6 = this_0.build_1k0s4u_k$();
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(new (Query())(tmp_1, tmp$ret$6)));
        });
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.employer_1).name_1 + ' \u2014 Monthly summary');
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.get_title_iz32un_k$()));
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        subtext(element, 'Money is shown once every day of the month has been remitted. Select a month for its breakdown by age group and provider type.');
        var tmp_2 = ($this$table, m) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (Button())($this$table.get_context_h02k06_k$());
          ensureOutermostElement(element);
          $this$table.willAddChild_hz2iwc_k$(element);
          element.set_action_2ds022_k$(Action('Month detail', VOID, VOID, VOID, VOID, VOID, EmployerMonthsPage$render$lambda$slambda(m, element, this)));
          element.onStartup_vrxh3i_k$();
          $this$table.addChild_2qpft2_k$(element);
          return element;
        };
        var tmp_3 = Companion_instance;
        var tmp_4 = EmployerMonthsPage$render$lambda;
        var tmp_5 = tmp_3.text_y5ktm4_k$(tmp_4, 1.2, EmployerMonthsPage$render$lambda_0);
        var tmp_6 = Companion_instance;
        var tmp_7 = EmployerMonthsPage$render$lambda_1;
        var tmp_8 = tmp_6.text_y5ktm4_k$(tmp_7, 0.7, EmployerMonthsPage$render$lambda_2);
        var tmp_9 = Companion_instance;
        var tmp_10 = EmployerMonthsPage$render$lambda_3;
        var tmp_11 = tmp_9.text_y5ktm4_k$(tmp_10, 0.7, EmployerMonthsPage$render$lambda_4);
        var tmp_12 = Companion_instance;
        var tmp_13 = EmployerMonthsPage$render$lambda_5;
        var tmp_14 = tmp_12.text_y5ktm4_k$(tmp_13, 0.7, EmployerMonthsPage$render$lambda_6);
        var tmp_15 = Companion_instance;
        var tmp_16 = EmployerMonthsPage$render$lambda_7;
        var tmp_17 = tmp_15.text$default_gwb2zv_k$(tmp_16, VOID, EmployerMonthsPage$render$lambda_8);
        var tmp_18 = Companion_instance;
        var tmp_19 = EmployerMonthsPage$render$lambda_9;
        var tmp_20 = tmp_18.text$default_gwb2zv_k$(tmp_19, VOID, EmployerMonthsPage$render$lambda_10);
        var tmp_21 = Companion_instance;
        var tmp_22 = EmployerMonthsPage$render$lambda_11;
        var tmp_23 = tmp_21.text$default_gwb2zv_k$(tmp_22, VOID, EmployerMonthsPage$render$lambda_12);
        var tmp_24 = Companion_instance;
        var tmp_25 = EmployerMonthsPage$render$lambda_13;
        table(element, this.months_1, tmp_2, [tmp_5, tmp_8, tmp_11, tmp_14, tmp_17, tmp_20, tmp_23, tmp_24.text$default_gwb2zv_k$(tmp_25, VOID, EmployerMonthsPage$render$lambda_14)]);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_4 = shownWhen(element, VOID, VOID, EmployerMonthsPage$render$lambda_15);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Space())(this_4.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'EmployerMonthsPage', VOID, VOID, [Page()]);
    EmployerMonthsPageClass = $;
  }
  return EmployerMonthsPageClass;
}
function monthFormat$lambda($this$Format) {
  _init_properties_EmployerMonthsPage_kt__pkjj37();
  $this$Format.monthName_asbkgr_k$(Companion_getInstance_1().ENGLISH_FULL_1);
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.year$default_dp2ctv_k$();
  return Unit_instance;
}
var properties_initialized_EmployerMonthsPage_kt_s3x8bj;
function _init_properties_EmployerMonthsPage_kt__pkjj37() {
  if (!properties_initialized_EmployerMonthsPage_kt_s3x8bj) {
    properties_initialized_EmployerMonthsPage_kt_s3x8bj = true;
    var tmp = Companion_instance_0;
    monthFormat = tmp.Format_1myt4u_k$(monthFormat$lambda);
  }
}
//region block: exports
export {
  EmployerMonthsPage as EmployerMonthsPagesopligyz03kb,
};
//endregion

//# sourceMappingURL=EmployerMonthsPage.mjs.map
